import React, { useMemo, useState } from 'react';
import comedora from '../assets/comedora-menu-logo-transparent.png';
import granada from '../img/granada.png';
import guasasapoSello from '../assets/trincheta-sello-nuevo-transparent.png';
import guasasapotv from '../img/gtv.png';
import trincheta from '../img/trincheta.png';
import trinchetaMenuLogo from '../assets/trincheta-menu-logo-transparent.png';
import comedoraFondoNuevo from '../assets/comedora-fondo-nuevo.jpg';
import comedoraCentroNuevo from '../assets/comedora-centro-nuevo-transparent-flipped.png';
import tomacoProducto from '../assets/comedora-producto-tomaco.png';
import champinonLeagueProducto from '../assets/comedora-producto-champinon-league.png';
import eduardianaProducto from '../assets/comedora-producto-eduardiana.png';

const navItems = ['INFO', 'PRODUCTOS', 'SERVICIOS', 'RECETAS', 'CONTACTO'];

const infoParagraphs = [
  'Todos los productos y alimentos que elaboramos han sido hechos por lxs mismxs integrantes de nuestra cooperativa, con mucho cariño y dedicación, continuando lo que comenzamos en el año 2017: crear un espacio de comida vegana, alejada de todo maltrato animal y producida de manera cooperativa y autogestionada.',
  'Nos gusta el contacto directo con quienes se relacionan con nuestros productos, vengan de donde vengan, pero especialmente a través de la vinculación estrecha con nuestrxs vecinxs de nuestro querido barrio. Siempre invitamos a todxs a conocernos, probar nuestros productos y apoyar el cooperativismo, creando este espacio de encuentro.',
  'Los recursos que ha generado la Comedora Guasasapo han hecho posible la autogestión de la cooperativa y todo el trabajo artístico, creativo y territorial que ésta ha desarrollado.',
  'Desde el año 2023, esta sección de producción ha cerrado debido a que nuestra cooperativa entró en periodo de hibernación.',
];

const brandMarks = [
  { src: guasasapoSello, alt: 'Guasasapo', href: '/guasasapo', className: 'comedora__navBrandMark--guasasapo' },
  { src: trincheta, alt: 'Trincheta', href: '/trincheta' },
  { src: granada, alt: 'Granada', href: '/granada' },
  { src: guasasapotv, alt: 'Guasasapo TV', href: '/guasasapotv' },
];

const products = [
  {
    title: 'EMPANADA “TOMACO”',
    description:
      'Nuestra empanada hecha a partir de la exitosa, histórica y popular pizza Tomaco de nuestro menú, con ingredientes: tomate, albahaca fresca, aceitunas negras y queso vegano.',
    image: tomacoProducto,
    alt: 'Empanada Tomaco de Comedora Guasasapo',
  },
  {
    title: 'EMPANADA “CHAMPIÑÓN LEAGUE”',
    description:
      'Empanada inspirada en una de las pizzas favoritas de nuestrxs seguidorxs, con ingredientes: champiñón, cebolla en cuadritos, ciboulette y queso vegano.',
    image: champinonLeagueProducto,
    alt: 'Empanada Champiñón League de Comedora Guasasapo',
  },
  {
    title: 'EMPANADA “EDUARDIANA”',
    description:
      'Otra empanada de las clásicas, también inspirada en una de las pizzas predilectas, con ingredientes: champiñón, berenjena, albahaca fresca y queso vegano.',
    image: eduardianaProducto,
    alt: 'Empanada Eduardiana de Comedora Guasasapo',
  },
];

const Comedora = () => {
  const [activeSection, setActiveSection] = useState(null);

  const heroContent = useMemo(() => {
    if (activeSection === 'info') {
      return (
        <div className="comedora__infoPanel" aria-label="Información de Comedora Guasasapo">
          {infoParagraphs.map((paragraph) => (
            <p key={paragraph} className="comedora__infoParagraph">
              {paragraph}
            </p>
          ))}
        </div>
      );
    }

    if (activeSection === 'productos') {
      return (
        <div className="comedora__productsPanel" aria-label="Productos de Comedora Guasasapo">
          {products.map((product) => (
            <article key={product.title} className="comedora__productCard">
              <div className="comedora__productMedia">
                <img src={product.image} alt={product.alt} className="comedora__productImage" />
              </div>
              <div className="comedora__productContent">
                <h2 className="comedora__productTitle">{product.title}</h2>
                <p className="comedora__productDescription">{product.description}</p>
              </div>
            </article>
          ))}
        </div>
      );
    }

    if (activeSection === 'contacto') {
      return (
        <div className="comedora__infoPanel" aria-label="Contacto de Comedora Guasasapo">
          <p className="comedora__infoParagraph">
            La Comedora Guasasapo se encuentra cerrada y sus redes sociales también no están operativas en el presente.
          </p>
          <p className="comedora__infoParagraph">
            Cualquier contacto puede hacerse a través del correo de la Cooperativa Guasasapo:{' '}
            <a href="mailto:contacto@guasasapo.cl" className="comedora__infoLink">
              contacto@guasasapo.cl
            </a>
          </p>
        </div>
      );
    }

    return (
      <>
        <div className="comedora__heroLogo" aria-label="Comedora">
          <img src={comedoraCentroNuevo} alt="Comedora Guasasapo" className="comedora__heroLogoMain" />
        </div>
        <div className="comedora__heroDivider" />
        <p className="comedora__tagline">Restorán popular de cocina vegana</p>
        <p className="comedora__subtitle">ALMUERZOS · REPOSTERÍA · PIZZAS · PRODUCTOS ELABORADOS</p>
      </>
    );
  }, [activeSection]);

  return (
    <div
      className="comedoraLanding"
      style={{
        backgroundImage: `linear-gradient(rgba(86, 70, 54, 0.34), rgba(86, 70, 54, 0.34)), linear-gradient(rgba(214, 199, 178, 0.32), rgba(214, 199, 178, 0.32)), url(${comedoraFondoNuevo})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <nav className="comedora__nav">
        <div className="comedora__navBrandCluster">
          <a href="/comedora" className="comedora__navLogo">
            <img src={comedora} alt="Comedora" />
          </a>

          <div className="comedora__navBrandMenu">
            {brandMarks.map((mark) => (
              <a key={mark.href} href={mark.href} className={`comedora__navBrandMark ${mark.className || ''}`}>
                <img src={mark.src} alt={mark.alt} />
              </a>
            ))}
          </div>
        </div>

        <div className="comedora__navRight">
          <ul className="comedora__navList">
            {navItems.map((item) => {
              const sectionKey = item.toLowerCase();
              return (
                <li key={item}>
                  <button
                    type="button"
                    className={`comedora__navLink ${activeSection === sectionKey ? 'comedora__navLink--active' : ''}`}
                    onClick={() => setActiveSection(sectionKey)}
                  >
                    {item}
                  </button>
                </li>
              );
            })}
          </ul>

          <img src={trinchetaMenuLogo} alt="Guasasapo Arte y Producción Cooperativa Abierta" className="comedora__navSupportLogo" />
        </div>
      </nav>

      <main className="comedora__main">
        <div className={`comedora__hero ${activeSection ? `comedora__hero--${activeSection}` : ''}`}>
          {heroContent}
        </div>
      </main>

      <footer className="comedora__footer">
        <span className="comedora__footerText">COMEDORA GUASASAPO</span>
        <span className="comedora__footerDot">&middot;</span>
        <span className="comedora__footerText">COOPERATIVA GUASASAPO</span>
      </footer>
    </div>
  );
};

export default Comedora;
